import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <a href="#hero" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/4e6899cadfb83a22fc80720bbcef0e10.png" 
              alt="Phượt Mỹ - Vui Khởi Nghĩ" 
              className="h-14 w-auto"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap cursor-pointer">Trang chủ</button>
            <button onClick={() => scrollToSection('itinerary')} className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap cursor-pointer">Lịch trình</button>
            <button onClick={() => scrollToSection('highlights')} className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap cursor-pointer">Điểm nổi bật</button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap cursor-pointer">Giá tour</button>
            <button onClick={() => scrollToSection('gallery')} className="text-gray-700 hover:text-[#2563eb] transition-colors whitespace-nowrap cursor-pointer">Thư viện</button>
            <button onClick={() => scrollToSection('final-cta')} className="px-6 py-2.5 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-full hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer font-semibold">
              Đăng ký ngay
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-[#2563eb] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('hero')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">Trang chủ</button>
            <button onClick={() => scrollToSection('itinerary')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">Lịch trình</button>
            <button onClick={() => scrollToSection('highlights')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">Điểm nổi bật</button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">Giá tour</button>
            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg transition-colors cursor-pointer">Thư viện</button>
            <button onClick={() => scrollToSection('final-cta')} className="block w-full px-4 py-2.5 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-lg hover:shadow-lg transition-all duration-300 cursor-pointer font-semibold">
              Đăng ký ngay
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
